<template>
    <address-list scope="organizations"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'OrganizationsAddressesList',

    components: {
        AddressList,
    },
};
</script>
